/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-06-07 09:36:46
 * @LastEditors: linxi
 * @LastEditTime: 2023-07-04 10:14:08
 */

import {
  Button,
  Col,
  Collapse,
  CollapseProps,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Space,
  Tag,
  Upload,
} from "antd"
import React, { ReactElement, useContext, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../app/store"
import styles from "./QA.module.css"
import { NavBar } from "../../compnents/nav/NavBar"
import { ThemeContext } from "../../theme/ThemeContext"
import { unwrapResult } from "@reduxjs/toolkit"
import { CaretUpFilled, DownOutlined, UpOutlined } from "@ant-design/icons"
import { QACreateModel } from "./QACreateModal"
import { getAnswerListAsync, getQaListAsync } from "./QASlice"

// 版本管理
export const QAmanagement = (): ReactElement => {
  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const [data, setData] = useState<any[]>([])

  const [updateDetail, setUpdateDetail] = useState<any>({})

  const [params, setParams] = useState({
    current: 1,
    size: 1000,
  })

  const [collapseStates, setCollapseStates] = useState<Record<string, boolean>>(
    {}
  )

  const [isAddModelVisible, setIsAddModelVisible] = useState(false)

  const toggleCollapse = (v: any) => {
    if(!collapseStates[v.id]) {
      dispatch(getAnswerListAsync({ ids: v.answerId }))
      .then(unwrapResult)
      .then(async (res: any) => {
        const newData: any =  []
        let url = ""
        const hostname = window.location.hostname
        if (hostname.includes("test")) {
          url =
            "https://his.test.hydhis.com/proxyToOssHydhisPublic/"
        } else if (
          hostname.includes("develop") ||
          hostname.includes("localhost")
        ) {
          url =
            "https://his.develop.hydhis.com/proxyToOssHydhisPublic/"
        }  else if (
          hostname.includes("36.213.47.39")
        ) {//无锡移动云
          url = "http://36.213.47.39:168/proxyToOssHydhisPublic"
        }else {
          url =
            "https://www.hydhis.cn/proxyToOssHydhisPublic/"
        }
        for (const m of res.list) {
          try {
            const response = await fetch(url + m.url)
            const html = await response.text()
            newData.push({
              title: m.title,
              url: m.url,
              content: html,
            })
          } catch (error) {
            console.error(`获取 ${m.url} 失败:`, error);
          }
        }
        setData(data?.map((n: any) => {
          return v.id == n.id ? { ...n, contentList: newData } : n
        }))
      })
    }
    setCollapseStates((prev) => ({
      ...prev,
      [v.id]: !prev[v.id],
    }))
  }

  const getPage = () => {
    dispatch(getQaListAsync({ ...params }))
      .then(unwrapResult)
      .then((v: any) => {
        setData(
          v?.records?.map((v: any) => {
            return { ...v, labelList: v?.label ? v?.label?.split(",") : [] }
          })
        )
      })
  }

  useEffect(() => {
    getPage()
  }, [])

  return (
    <Col
      style={{
        height: "calc(100% - 20px) ",
        overflow: "hidden",
        // margin: "10px 30px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* <NavBar
        where={["QA管理", ""]}
        buttons={
          <Button type="primary" onClick={() => setIsAddModelVisible(true)}>
            新增
          </Button>
        }
        type={false}
      /> */}
      <Col
        style={{
          // flex: 1,
          overflow: "auto",
          // backgroundColor: theme.pn,
          marginTop: 10,
          borderRadius: 10,
          padding: "10px 0px",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Row style={{ width: '100%',marginBottom: 15 }} justify="end">
          <Button type="primary" onClick={() => {
            setUpdateDetail(null)
            setIsAddModelVisible(true)
            }}>
            新增
          </Button>
        </Row>
        {data?.map((v: any) => {
          return (
            <>
              <Row
                className={styles.titleContent}
                style={{ backgroundColor: theme.pn }}
                key={v.id}
                onDoubleClick={(e) => {
                  setUpdateDetail(v)
                  setIsAddModelVisible(true)
                }}
              >
                <Space direction="vertical" className={styles.space}>
                  <Collapse
                    className={styles.head}
                    collapsible="header"
                    ghost
                    onChange={() => toggleCollapse(v)}
                  >
                    <Collapse.Panel
                      key={v.id}
                      header={
                        <div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                fontWeight: "bold",
                                fontSize: 17,
                                textAlign: "left",
                              }}
                            >
                              <span>{v.title}</span>
                              <div className={styles.labels}>
                                {v.labelList?.map((item: any) => (
                                  <Tag key={item}>{item}</Tag>
                                ))}
                              </div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 4,
                              }}
                            >
                              <span>展开</span>
                              {collapseStates[v.id] ? (
                                <DownOutlined
                                  style={{ fontSize: 16, color: "#1684FC" }}
                                />
                              ) : (
                                <UpOutlined
                                  style={{ fontSize: 16, color: "#1684FC" }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      }
                      showArrow={false}
                    >
                      { v?.contentList?.map((m: any) => {
                        return (
                          <div className={styles.content} key={m.url}>
                            <div
                              style={{
                                fontSize: "15px",
                                fontWeight: "bold",
                                margin: "10px 0",
                              }}
                            >
                              {m.title}
                            </div>
                            <div className={styles.rightContent} dangerouslySetInnerHTML={{ __html: m.content }}></div>
                          </div>
                        )
                      })}
                    </Collapse.Panel>
                  </Collapse>
                </Space>
              </Row>
            </>
          )
        })}
      </Col>

      <QACreateModel
        visible={isAddModelVisible}
        updateDetail={updateDetail}
        onCancel={() => setIsAddModelVisible(false)}
        onOk={() => {
          setIsAddModelVisible(false)
          getPage()
        }}
      />
    </Col>
  )
}
